import React, { useEffect, useState } from "react";
import {
  Checkbox,
  DialogContent,
  DialogTitle,
  Dialog,
  TextField,
  TextareaAutosize
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { CustomButton } from "../../components/Common/CustomButton";
import styled from "styled-components";
import { useFormik } from "formik";
import * as yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { createSmstemplate, getSmstemplate } from "../../redux/smstemplate/action";
export const TitleInput = styled("p")(({ theme }) => ({
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 10,
  }));
  
  export const BoxInput = styled("div")(({ theme }) => ({
    
    marginBottom:'10px'
  }));
const useStyles = makeStyles((theme) => ({
    textFieldError: {
        "& input": {
          border: "1px solid red",
          color: "red",
        },
        "& p": {
          color: "red",
          marginLeft:0,
        },
      },
  customModalContent: {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  customModal: {
    width: "calc(100% - 20px)",
    marginLeft: "10px",
    marginRight: "10px",
  },
  customModalTitle: {
    padding: "10px 15px",
    color: "#fff",
    background: process.env.NODE_ENV === 'development' ? "#5a8dee" : process.env.REACT_APP_PRODUCT_BASE_COLOR,
    marginBottom:'15px',
  },
}));

const validationSchema = yup.object({
  // name: yup.string().required('Bạn chưa nhập tên phòng ban'),
});

const SmsTempCreate = (props) => {
  const classes = useStyles();
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();


  // const handleCheck = (e) => {
  //   setActive(e.target.checked);
  //   setFieldValue("activate", e.target.checked);
  // };

  const { values, handleSubmit, handleChange, setFieldValue } =
  useFormik({
    initialValues: {
      name: "",
      msg_tem: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
   
        dispatch(createSmstemplate(values));
        
      },
  });


const createSuccess = useSelector(
  (item) => item.smstemplateReducer.createSuccess
);

useEffect(() => {
  if (createSuccess) {
    props.onClose();
    dispatch(getSmstemplate())
  }
  // eslint-disable-next-line
}, [createSuccess]);



  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={true}
      onClose={props.onClose}
      style={{ minHeight: "100%" }}
      classes={{
        paper: classes.customModal,
      }}
    >
      <DialogTitle className={`${classes.customModalTitle}`}>
        Mẫu SMS
        <IconButton
          onClick={props.onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={`${classes.customModalContent}`}>
          

      <BoxInput>
            <TitleInput>Tên</TitleInput>
            <TextField
              size="small"
              name="name"
              fullWidth
              placeholder="Tên"
              onChange={handleChange}
              value={values.name}
            />
          </BoxInput>
          {/* <BoxInput>
            <TextField
              
              size="small"
              name="telco"
              fullWidth
              placeholder="Telco"
              onChange={handleChange}
              value={values.telco}
            />
          </BoxInput> */}
          <BoxInput>
            <TitleInput>Tin nhắn</TitleInput>
            <TextareaAutosize
              size="small"
              name="msg_tem"
              fullWidth
              placeholder="Message"
              onChange={handleChange}
              value={values.msg_tem}
            />
          </BoxInput>
          <BoxInput style={{display:'flex'}}>
            <TitleInput>Active</TitleInput>
            
              <Checkbox style={{marginTop:'-12px'}}
                id="activate"
                name="activate"
                checked={active}
                onChange={(e) => {
                  setFieldValue(
                    "activate",
                    e.currentTarget.checked
                  );
                  setActive(e.currentTarget.checked);
                }}
                />
          </BoxInput>

          <CustomButton
            // color="primary"
            variant="contained"
            type="submit"
            onClick={() => handleSubmit()}
            style={{marginLeft:'auto'}}
          >
            Thêm 
          </CustomButton>

      </DialogContent>
    </Dialog>
  );
};

export default SmsTempCreate;